// extracted by mini-css-extract-plugin
module.exports = {"box":"box--3jT9A","article":"article--UaWE3","title":"title--6+Xpr","date":"date--4lUi0","content":"content--64CoL"};